import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import _ from 'lodash';

import TicketList from '../../tickets/containers/TicketList';
import { queryGetAllMonthlyBonusTicketsGQL } from '../graphql/allTicketsForMonthApi';

import { setTicketId } from '../actions';
import { getTicketId, getBonusMonth, getDistrictId, getShowProcessed } from '../selectors';

const mapStateToProps = (state) => {
  return {
    currentTicketId: getTicketId(state),
    districtId: getDistrictId(state),
    bonusMonth: getBonusMonth(state),
    showProcessed: getShowProcessed(state),
  };
};

const mapDispatchToProps = {
  setTicketIdAction: setTicketId,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withSelectFirstTicket = lifecycle({
  componentWillMount() {
    const { allTickets, setTicketIdAction, currentTicketId } = this.props;

    if (allTickets.length > 0 && !currentTicketId) {
      setTicketIdAction(allTickets[0].id);
    } else if (allTickets.length > 0 && currentTicketId) {
      const currentIndex = _.findIndex(allTickets, { id: currentTicketId });

      const index = (currentIndex === -1) ? 0 : currentIndex;
      setTicketIdAction(allTickets[index].id);
    }

    if (allTickets.length === 0) {
      setTicketIdAction(null);
    }
  },
});

const enhance = compose(
  withRedux,
  queryGetAllMonthlyBonusTicketsGQL,
  withSelectFirstTicket,
);

export default enhance(TicketList);
